import { BottomSheet } from '@/components/atoms/bottomsheet';
import { ComparativeContent, MunicipalityComparativeContent } from '../content';
import type { SheetRef } from 'react-modal-sheet';
import type { RefObject } from 'react';
import { Box } from '@mui/material';

interface MunicipalityCompareBottomSheetProps {
  open: boolean;
  onClose: () => void;
  municipalityData: MunicipalityComparativeContent;
  onGetMunicipalitiesComparative: (municipalities: MunicipalityComparativeContent[]) => void;
  savedSelections: MunicipalityComparativeContent[];
  limit: number;
  bottomSheetRef: RefObject<SheetRef | null>;
}

export const MunicipalityCompareBottomSheet = ({
  open,
  onClose,
  municipalityData,
  onGetMunicipalitiesComparative,
  savedSelections,
  limit,
  bottomSheetRef,
}: MunicipalityCompareBottomSheetProps) => {
  return (
    <BottomSheet
      isOpen={open}
      onClose={onClose}
      ref={bottomSheetRef}
      snapPoints={[1, 1, 0]}
      initialSnap={1}
    >
      <Box sx={{ height: '100%', overflowY: 'auto' }}>
        <ComparativeContent
          municipalityData={municipalityData}
          open={open}
          onClose={onClose}
          onGetMunicipalitiesComparative={onGetMunicipalitiesComparative}
          savedSelections={savedSelections}
          limit={limit}
        />
      </Box>
    </BottomSheet>
  );
};
